<template>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 15 32"
	> <path d="M0.438 27.125l11.125-11.125-11.125-11.125c-0.625-0.625-0.625-1.563 0-2.188 0.563-0.625 1.563-0.625 2.188 0l12.188 12.25c0.625 0.625 0.625 1.5 0 2.125l-12.188 12.25c-0.625 0.625-1.625 0.625-2.188 0-0.625-0.625-0.625-1.563 0-2.188z" /></svg>
</template>
